export default __webpack_public_path__ + "static/media/noe-display-bold.c804b97f.svg";